// src/Navbar.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFocusMode } from './FocusModeContext';
import { useState, useRef, useEffect } from 'react';
// import logoUrl from "/images/misc/tutororca.react.svg";
import './App.css';

export default function Navbar({ userName, handleSignOut }) {
  const navigate = useNavigate();
  const { focusMode, toggleFocusMode, } = useFocusMode();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();
  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedGrade,   setSelectedGrade]   = useState('');
  const [showSelect,      setShowSelect]      = useState(false);
  const [showActions, setShowActions] = useState(false);
const location = useLocation();
const hideContinueOnThisPage = location.pathname.startsWith('/subscriber-dashboard');
const isRequestDemoLanding = location.pathname === '/request-demo-class';

function normalizeGrade(g) {
  if (!g) return '';
  const s = String(g).trim();

  // ✅ allow KG / Kindergarten
  if (s.toUpperCase() === 'KG' || s.toLowerCase() === 'kindergarten') return 'KG';

  // ✅ allow "4thGrade" or "4"
  const match = s.match(/^(\d+)/);
  return match ? match[1] : '';
}

useEffect(() => {
  const sub = localStorage.getItem('subscribedSubject');
  const gr  = localStorage.getItem('subscribedGrade');
  if (sub) setSelectedSubject(sub);
  if (gr) setSelectedGrade(normalizeGrade(gr));
}, []);
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const ordinal = (n) => {
  const s = ['th','st','nd','rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const getSubjectSlug = (subj) => {
  if (!subj) return '';
  const s = subj.trim().toLowerCase();
  if (['math','maths','mathematics'].includes(s)) return 'Math';
  if (['science','sciences'].includes(s)) return 'Science';
  return subj.replace(/\s+/g, '');
};

const handleContinueQuiz = () => {
  const subject = selectedSubject || localStorage.getItem('subscribedSubject');
  const rawGrade = selectedGrade || localStorage.getItem('subscribedGrade');
  const grade = normalizeGrade(rawGrade);

  if (!subject || !grade) {
    alert("Please set a valid subject and grade before continuing.");
    setShowSelect(true);
    return;
  }

  const slug = getSubjectSlug(subject);

  // ✅ KG special case (no number check)
  if (grade === 'KG') {
    navigate(`/quiz/${slug}/KG`);
    return;
  }

  // ✅ numeric grades only from here
  if (isNaN(Number(grade))) {
    alert("Please set a valid subject and grade before continuing.");
    setShowSelect(true);
    return;
  }

  navigate(`/quiz/${slug}/${ordinal(Number(grade))}Grade`);
};

  // wipe out exactly what App.js reads for redirect
const handleResetGrade = () => {
  localStorage.removeItem('subscribedGrade');
  
  const previousSubject = localStorage.getItem('subscribedSubject');

  if (previousSubject === 'Maths') {
    localStorage.setItem('subscribedSubject', 'Math'); // normalize it
    navigate('/subject/Math'); // auto-select Math
  } else {
    localStorage.removeItem('subscribedSubject'); // clear completely if not Maths
    navigate('/subject'); // let user pick again
  }
};

  if (isRequestDemoLanding) {
    return (
      <header className="request-demo-landing-header" aria-label="TutorOrca">
        <img
          src="/images/misc/tutororca.react.svg"
          alt="TutorOrca"
          width="88"
          height="54"
          decoding="async"
          fetchpriority="high"
          style={{ display: 'block', cursor: 'pointer' }}
          onClick={() => navigate('/')}
        />
      </header>
    );
  }

  return (
<div className="navbar-left">
  <img
   src="/images/misc/tutororca.react.svg"
   alt="TutorOrca"
   width="88"
   height="54"
   decoding="async"
   fetchpriority="high"
   style={{ display: 'block', cursor: 'pointer' }}
   onClick={() => navigate('/')}
 />


<div className="navbar-right" style={{ display: 'flex', alignItems: 'flex-start', flex: '0 0 auto', justifyContent: 'flex-end' }}>
  {userName && (
    <div
      className="navbar-user-group"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        position: 'relative',
        marginRight: '32px',
        minWidth: 220,
      }}
      ref={dropdownRef}
    >
      {/* Dropdown Button */}
      <button
        style={{
          background: 'none',
          border: 'none',
          color: '#222',
          fontWeight: 'bold',
          fontSize: '1.1rem',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          padding: 0,
        }}
        onClick={() => setShowDropdown((v) => !v)}
      >
        Hello {userName}
      </button>
      {/* Dropdown Menu */}
      {showDropdown && (
        <div
          style={{
            position: 'absolute',
            right: 0,
            marginTop: 8,
            background: '#fff',
            border: '1px solid #ddd',
            borderRadius: 6,
            minWidth: 160,
            boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
            zIndex: 999,
          }}
        >
          <button
            style={{
              width: '100%',
              padding: '10px 18px',
              background: 'none',
              border: 'none',
              textAlign: 'left',
              cursor: 'pointer',
            }}
          onClick={() => {
  const plan = (localStorage.getItem('subscriptionStatus') || '').trim().toLowerCase();
  // Handle all valid subscriber plans
  const subscriberPlans = ['monthly', 'yearly', 'freetrial'];
  if (subscriberPlans.includes(plan)) {
    navigate('/subscriber-dashboard');
  } else {
    navigate('/signup-home');
  }
}}
>
  Manage Account
</button>
          <button
            style={{
              width: '100%',
              padding: '10px 18px',
              background: 'none',
              border: 'none',
              textAlign: 'left',
              cursor: 'pointer',
              color: '#e53935',
            }}
            onClick={async () => {
              setShowDropdown(false);
              await handleSignOut(); // Ensure localStorage is cleared
              navigate('/');         // Navigate after sign-out
            }}
          >
            Sign Out
          </button>
        </div>
      )}
  {/* Continue Quiz Button */}
  {/* Action Row */}
{!hideContinueOnThisPage && (
  <>
<div
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginTop: 10
  }}
>
  {/* Continue Quiz */}
  <button
    style={{
      padding: '6px 14px',
      backgroundColor: '#4caf50',
      color: 'white',
      border: 'none',
      borderRadius: 6,
      cursor: 'pointer',
      fontWeight: 'bold',
      fontSize: '0.85rem'
    }}
    onClick={handleContinueQuiz}
  >
    Continue Quiz 🚀
  </button>

  {/* Toggle more actions */}
  <button
    onClick={() => setShowActions(v => !v)}
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: '0.85rem',
      color: '#555'
    }}
  >
    {showActions ? 'Hide ▲' : 'More ▼'}
  </button>
</div>


  {/* Subject/Grade Dropdown if required */}
  {showSelect && (
    <div style={{
      marginTop: 16,
      background: '#fff',
      border: '1px solid #ddd',
      borderRadius: 8,
      padding: 20,
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      maxWidth: 300,
      textAlign: 'left'
    }}>
      <h4 style={{ marginBottom: 10 }}>Set Your Subject and Grade</h4>
      <div style={{ marginBottom: 10 }}>
        <label>
          Subject:
          <select
            value={selectedSubject}
            onChange={e => setSelectedSubject(e.target.value)}
            style={{ marginLeft: 8, padding: 6, borderRadius: 4 }}
          >
            <option value="">Select Subject</option>
            <option value="Math">Math</option>
            <option value="Science">Science</option>
          </select>
        </label>
      </div>
      <div style={{ marginBottom: 10 }}>
        <label>
          Grade:
          <select
            value={selectedGrade}
            onChange={e => setSelectedGrade(e.target.value)}
            style={{ marginLeft: 8, padding: 6, borderRadius: 4 }}
          >
            <option value="">Select Grade</option>
            {['KG','1','2','3','4','5','6','7','8','9','10'].map(gr => (
              <option key={gr} value={gr}>
                {gr === 'KG' ? 'KG' : `${gr} Grade`}
              </option>
            ))}
          </select>
        </label>
      </div>
      <button
        style={{
          background: '#4caf50',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          padding: '8px 12px',
          fontWeight: 'bold',
          cursor: 'pointer'
        }}
        onClick={() => {
          if (!selectedSubject || !selectedGrade) {
            alert('Please select both subject and grade.');
            return;
          }

          localStorage.setItem('subscribedSubject', selectedSubject);
          localStorage.setItem('subscribedGrade', selectedGrade);
          setShowSelect(false);
          handleContinueQuiz(); // ✅ retry navigation
        }}
      >
        Save and Start Quiz
      </button>
    </div>
  )}
</>
)}
    
      {/* Focus Mode and Ambient Sound stacked VERTICALLY */}
{showActions && (
  <div
    style={{
      marginTop: 8,
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }}
  >
    {/* Focus Mode */}
    <div style={{ fontSize: '0.9rem', color: '#444' }}>
      Focus Mode:
      <button
        onClick={toggleFocusMode}
        style={{
          marginLeft: 6,
          padding: '2px 10px',
          fontSize: '0.85rem',
          borderRadius: 6,
          border: '1px solid #2196f3',
          backgroundColor: focusMode ? '#bbdefb' : '#eeeeee',
          cursor: 'pointer'
        }}
      >
        {focusMode ? 'Enabled' : 'Disabled'}
      </button>
    </div>

    {/* Reset Grade */}
    <button
      onClick={handleResetGrade}
      style={{
        padding: '4px 10px',
        backgroundColor: '#ff9800',
        color: 'white',
        border: 'none',
        borderRadius: 6,
        cursor: 'pointer',
        fontSize: '0.85rem'
      }}
    >
      Reset Grade
    </button>
  </div>
)}


    </div>
  )}
</div>

    </div>
  );
}
